'use client';
import React from 'react';
import { toast } from 'sonner';

export const HowToBridge = () => {
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard!');
  };
  const steps = [
    {
      id: 1,
      boxClass:
        'max-w-[387px] xl:mr-[47px] max-xl:mb-[50px] pt-[58px] h-[336px] w-full border-4 border-[#009BAF] rounded-[23px] relative',
      badgeImg: '/assets/01.png',
      badgeExtra: '',
      content: (
        <div className="max-w-[266px] w-full mx-auto">
          <div className="pb-3 text-2xl font-normal font-koulen text-[#D6FF00] leading-[130%]">
            Copy the Bridge Contract Address
          </div>
          <div className="relative text-lg font-koulen leading-[130%] text-white">
            <div className="w-3 h-3 rounded-full bg-[#D6FF00] absolute top-2 left-[-20px] lg:left-[-30px]"></div>
            <p>You'll find the official L1 → L2 bridge address here:</p>
            <br />
            <p className="flex gap-2 items-center">
              Bridge Contract (Sepolia L1):{' '}
              <img
                src="/assets/solar_copy-bold.png"
                className="cursor-pointer"
                onClick={() => handleCopy('https://testnet-tx-rpc.layerbrettchain.com')}
                alt="copy"
              />
            </p>
            <p className="text-[#FFB3E8] break-all">0x10Ec8159a9B1D7b7A1154E9a5b89FCeCd027B222</p>
          </div>
        </div>
      ),
    },
    {
      id: 2,
      boxClass:
        'max-w-[387px] xl:mr-[54px] max-xl:mb-[50px] pt-[58px] h-[336px] w-full border-4 border-[#009BAF] rounded-[23px] relative',
      badgeImg: '/assets/02.png',
      badgeExtra: (
        <>
          <img src="/assets/IMG_0967 2.png" className="hidden lg:flex absolute bottom-0 right-[14px]" />
          <img src="/assets/IMG_0967 1.png" className=" lg:hidden absolute bottom-0 right-[0px]" />
        </>
      ),

      content: (
        <div className="max-w-[266px] w-full mx-auto">
          <div className="pb-3 text-2xl font-normal font-koulen text-[#D6FF00] leading-[130%]">
            <span className="flex gap-2 items-center">
              Open MetaMask <img src="/assets/Group 1597885998.png" className="w-[36px] h-[36px]" alt="" />
            </span>{' '}
            (or any EVM wallet)
          </div>
          <div className="relative text-lg font-koulen leading-[130%] text-white">
            <div className="w-3 h-3 rounded-full bg-[#D6FF00] absolute top-2 left-[-20px] lg:left-[-30px]"></div>
            <p>Select the Sepolia network</p>
          </div>
        </div>
      ),
    },
    {
      id: 3,
      boxClass:
        'max-w-[457px] xl:mr-[54px] max-xl:mb-[50px] pt-[58px] h-[424px] lg:h-[336px] w-full border-4 border-[#009BAF] rounded-[23px] relative',
      badgeImg: '/assets/03.png',
      badgeExtra: '',
      content: (
        <div className="max-w-[277px] lg:max-w-[346px] w-full mx-auto">
          <div className="pb-3 text-2xl max-w-[300px] font-normal font-koulen text-[#D6FF00] leading-[130%]">
            Send Sepolia ETH to the Bridge Contract
          </div>
          <p className="text-lg pb-5 font-normal font-koulen leading-[130%]">
            Use the standard <span className="text-[#D6FF00]"> “Send” </span> function in your wallet.
          </p>

          {[
            {
              label: 'Recipient:',
              text: 'Bridge contract address',
            },
            {
              label: 'Amount:',
              text: (
                <>
                  Any amount works{' '}
                  <span className="text-[#21CCFB]">
                    (<span className="text-[#2CFB21]">0.02–0.1 ETH</span> recommended for testing)
                  </span>
                </>
              ),
            },
            {
              label: 'Gas:',
              text: 'Paid in Sepolia ETH',
            },
          ].map((i, index) => (
            <div key={index} className="relative pb-5 text-lg font-koulen leading-[130%] text-white">
              <div className="w-3 h-3 rounded-full bg-[#D6FF00] absolute top-1 left-[-20px] lg:left-[-30px]"></div>
              <p>
                <span className="text-[#FFB3E8]">{i.label}</span> {i.text}
              </p>
            </div>
          ))}
        </div>
      ),
    },
  ];
  return (
    <div className="pt-[38px] lg:pt-[170px] " id="bridge-sepo">
      <div className="max-w-[1400px] w-full mx-auto relative">
        <img
          src="/assets/t fighter 1.svg"
          className="lg:absolute top-[15%] mx-auto pb-[22px] left-[-8%] max-w-[205px] z-0  lg:block"
          alt=""
        />
        <div className="max-w-[863px] hidden lg:block mx-auto w-full relative">
          <img src="/assets/arrow 1.png" className="absolute right-[65px] top-4 z-0 max-w-[125px] w-full" alt="" />
          {/* Top Row */}
          <div className="flex max-w-[620px] w-full justify-between items-center">
            <span className="text-[62px] font-koulen font-normal leading-[136%] uppercase">HOW TO BRIDGE</span>

            <img src="/assets/Sepolia ETH2.png" className="max-w-[275px] w-full" alt="Sepolia ETH" />
          </div>

          <h2 className="schwifty ml-[116px] text-[#D6FF00] text-[123px] font-normal leading-[100%] rotate-[-6deg]">
            Layer Brett
          </h2>

          {/* Optional: “Instant Send Method” like screenshot */}
          <span className="absolute right-[-26px] -bottom-10 text-white font-koulen text-[40px] leading-[136%] uppercase tracking-[-4%]">
            (Instant Send Method)
          </span>
        </div>
        <img src="/assets/Group 1597886055.png" className="lg:hidden" alt="" />
        <p className="max-w-[938px] pt-[100px] max-lg:px-4 w-full uppercase mx-auto text-center pb-10 lg:pb-[105px] text-2xl font-koulen leading-[130%] ">
          <span className="text-[#00D2ED]"> Layer Brett </span> uses a direct-send bridge, meaning you don’t need a UI
          or approval steps. <br />
          <br />
          To bridge <span className="text-[#FFB3E8]"> Sepolia </span> ETH to{' '}
          <span className="text-[#00D2ED]"> Layer Brett </span> , just send it{' '}
          <span className="text-[#D6FF00]"> directly to the official bridge contract address. </span>
        </p>

        <div className="flex max-lg:px-4 lg:mb-[53px] flex-col xl:flex-row justify-center">
          {steps.map((step, index) => (
            <div key={step.id} className={step.boxClass}>
              {step.badgeExtra}
              <span
                className={`max-w-[146px] px-[19px] flex items-center gap-[14px] absolute ${
                  index === 0
                    ? ' left-[50%] max-lg:-translate-x-1/2 lg:left-[45px] xl:left-[-58px]'
                    : 'left-[50%] max-lg:-translate-x-1/2 lg:left-[45px]'
                }  top-[-26px] w-full shadow-outerDesk h-[50px] justify-center rounded-[5px] bg-[#FFB3E8] border-4 border-[#EF53C0C0]`}
              >
                <span className="text-[#003E57] text-[20px] font-koulen">Step</span>
                <img src={step.badgeImg} alt="" />
              </span>

              {step.content}
            </div>
          ))}
        </div>
        <div className="flex max-lg:px-4 flex-col xl:flex-row  relative">
          <img
            src="/assets/alien16.png"
            className="absolute right-[-90px] top-[-50px] z-0 lg:block hidden max-w-[109px] rotate-[-21.39deg]"
            alt=""
          />

          <div className="max-w-[387px] hidden lg:block w-full xl:mr-[47px] relative">
            <img src="/assets/alien10 1.svg" className="max-w-[155px] w-full" alt="" />
          </div>

          <div className="max-w-[387px] xl:mr-[60px] max-xl:mb-[50px] pt-[58px] h-[336px] w-full border-4 border-[#009BAF] rounded-[23px] relative">
            <span className="max-w-[146px]  px-[19px] flex items-center gap-[14px] absolute left-[50%] max-lg:-translate-x-1/2 lg:left-[45px]   top-[-26px] w-full  shadow-outerDesk h-[50px]  justify-center rounded-[5px] bg-[#FFB3E8] border-4 border-[#EF53C0C0]">
              <span className="text-[#003E57] text-[20px] font-koulen">Step</span>
              <img src="/assets/04.png" alt="" />
            </span>
            <div className="max-w-[266px] w-full mx-auto">
              <div className="pb-3 text-2xl font-normal font-koulen text-[#D6FF00] leading-[130%]">
                Wait for Confirmation
              </div>
              <div className="relative pb-5 text-lg font-koulen leading-[130%] text-white">
                <div className="w-3 h-3 rounded-full bg-[#D6FF00] absolute top-1 -left-5 lg:left-[-30px]"></div>
                <p>
                  After the Sepolia transaction confirms, the bridge will automatically credit you with ETH on the Layer
                  Brett Testnet.
                </p>
              </div>
            </div>
          </div>

          <div className="max-w-[387px] xl:mr-[54px] max-xl:mb-[50px] pt-[58px] h-[336px] w-full border-4 border-[#009BAF] rounded-[23px] relative">
            <span className="max-w-[146px]  px-[19px] flex items-center gap-[14px] absolute left-[50%] max-lg:-translate-x-1/2 lg:left-[45px]   top-[-26px] w-full  shadow-outerDesk h-[50px]  justify-center rounded-[5px] bg-[#FFB3E8] border-4 border-[#EF53C0C0]">
              <span className="text-[#003E57] text-[20px] font-koulen">Step</span>
              <img src="/assets/05.png" alt="" />
            </span>
            <div className="max-w-[266px] w-full mx-auto">
              <div className="pb-3 text-2xl max-w-[300px] font-normal font-koulen text-[#D6FF00] leading-[130%]">
                AAAAND....Done!
              </div>

              <div className="relative pb-5 text-lg font-koulen leading-[130%] text-white">
                <div className="w-3 h-3 rounded-full bg-[#D6FF00] absolute top-1 -left-5 lg:left-[-30px]"></div>
                <p>Send transactions</p>
              </div>
              <div className="relative pb-5 text-lg font-koulen leading-[130%] text-white">
                <div className="w-3 h-3 rounded-full bg-[#D6FF00] absolute top-1 -left-5 lg:left-[-30px]"></div>
                <p>Deploy contracts</p>
              </div>

              <div className="relative pb-5 text-lg font-koulen leading-[130%] text-white">
                <div className="w-3 h-3 rounded-full bg-[#D6FF00] absolute top-1 -left-5 lg:left-[-30px]"></div>
                <p>Use the AI meme explorer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
